import { render, staticRenderFns } from "./TrainingCalendarWeek.vue?vue&type=template&id=252b560c&scoped=true&"
import script from "./TrainingCalendarWeek.vue?vue&type=script&lang=ts&"
export * from "./TrainingCalendarWeek.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingCalendarWeek.vue?vue&type=style&index=0&id=252b560c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252b560c",
  null
  
)

export default component.exports